import http from '../http';

export async function createSale(payload) {
  const { data } = await http.post('/api/sales', payload);
  return data;
}

export async function getSales(params={}) {
  const { data } = await http.get('/api/sales', { params });
  return data;
}

export async function getReport(params={}) {
  const { data } = await http.get('/api/sales/report', { params });
  return data;
}
